// 异步请求变量

export const UCENTER = '/api/ucenter'

export const BASIC = '/api/basic'

export const EMER = '/api/emer'




// WEBPACK FOOTER //
// ./src/data/requers_variable.js